import { Grid, Paper, TextField, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React, { useContext, useEffect } from "react";
import kavidaLogo from "../../assets/images/kavida_logo.webp";
import { companyRegistration, UJAvailableLocation } from "../../services/api.service";
import { userJourneyContext } from "../../states/context/userJourneyContext";
import formBackgroundImg from "../../assets/images/formBackgroundImg.webp";
import Loader from "../common/loader";
import "./CompanyRegistrationForm.css";
import Autocomplete from '@material-ui/lab/Autocomplete';

const CompanyRegistrationForm = () => {
  const userContext = useContext(userJourneyContext);
  const [password, setPassword] = React.useState("");
  const [company, setCompany] = React.useState("");
  const [warehouse, setWarehouse] = React.useState("");
  const [role, setRole] = React.useState(userContext.userJourneyInfo.role);
  const [loading, setLoading] = React.useState(false);
  const [isCreated, setIsCreated] = React.useState(false);
  const [userName, setUserName] = React.useState(userContext.userJourneyInfo.name)
  const [userEmail, setUserEmail] = React.useState(userContext.userJourneyInfo.email)
  const [locations, setLocations] = React.useState([]);
  const redirect_url = process.env.REACT_APP_HOST;
  const classes = useStyles();

  const handleClick = () => {
    (async () => {
      try {
        setLoading(true);
        let payload = {
          form_id: null,
          user_name: userName,
          user_email: userEmail,
          user_phone: "-",
          user_password: password,
          company_name: company,
          company_warehouse: warehouse,
          role: role,
          user_journey_complete: true,
        };
        const result = await companyRegistration(payload);
        if (result.data.registration_success) {
          setIsCreated(true)
          setLoading(false);
          window.location.replace(redirect_url);
        } else {
          setLoading(false);
        }

      } catch (e) {
        console.log(e);
      }
    })();
  };

  useEffect(() => {
    (async () => {
      try {
        const locationData = {
          api_name: 'uj_available_location',
          data: {
            form_id: "UJ"
          }
        }
        const { data, meta } = await UJAvailableLocation(locationData);
        if (meta.status === 200) {
          setLocations(data);
        }
      } catch (e) {
        console.log(e);
      }
    })();
  }, [])

  const onChangeLocation = (e) => {
    setWarehouse(e.target.value)
  };

  return (
    <div style={{ backgroundImage: `url(${formBackgroundImg})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>

      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ minHeight: "100vh" }}
      >

        <Paper elevation={24} className={classes.root}>
          {loading ?
            <div style={{ marginLeft: "-61px" }}>
              <Loader></Loader>
            </div>
            :
            <Grid container className={classes.containerStyle}>
              <Grid container>
                <Grid item xs={12}>
                  <img
                    src={kavidaLogo}
                    style={{
                      width: "138px",
                      height: "52px",
                      marginLeft: "112px",
                    }}
                    alt={"KAVIDA"}
                  />
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12}>
                  <Typography
                    variant="body1"
                    className={classes.titleStyle}
                    align="center"
                  >
                    Create your Kavida account
                  </Typography>
                  <Typography className={classes.subTitleStyle} align="center">
                    To sign up, fill in the following details:
                  </Typography>
                </Grid>
              </Grid>
              <Grid container className={classes.formContainerStyle}>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography className={classes.labelStyle}>
                      Name
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      className={classes.textFieldStyle}
                      inputProps={{
                        className: classes.inputTextStyle,
                      }}
                      InputProps={{
                        classes: {
                          notchedOutline: classes.outlineStyle,
                        },
                      }}
                      fullWidth
                      defaultValue={userContext.userJourneyInfo.name && userContext.userJourneyInfo.name}
                      onChange={(event) => setUserName(event.target.value)}
                    />
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography className={classes.labelStyle}>
                      Email
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      id="username"
                      name="username"
                      type="email"
                      className={classes.textFieldStyle}
                      inputProps={{
                        className: classes.inputTextStyle,
                      }}
                      InputProps={{
                        classes: {
                          notchedOutline: classes.outlineStyle,
                        },
                      }}
                      fullWidth
                      defaultValue={userContext.userJourneyInfo.email && userContext.userJourneyInfo.email}
                      onChange={(event) => setUserEmail(event.target.value)}
                    />
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography className={classes.labelStyle}>Password</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      type={"password"}
                      id="password"
                      name="password"
                      className={classes.textFieldStyle}
                      inputProps={{
                        className: classes.inputTextStyle,
                      }}
                      InputProps={{
                        classes: {
                          notchedOutline: classes.outlineStyle,
                        },
                      }}
                      fullWidth
                      onChange={(event) => setPassword(event.target.value)}
                    />
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography className={classes.labelStyle}>Role</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      className={classes.textFieldStyle}
                      inputProps={{
                        className: classes.inputTextStyle,
                      }}
                      InputProps={{
                        classes: {
                          notchedOutline: classes.outlineStyle,
                        },
                      }}
                      fullWidth
                      defaultValue={userContext.userJourneyInfo.role && userContext.userJourneyInfo.role}
                      onChange={(event) => setRole(event.target.value)}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Typography className={classes.labelStyle}>Company</Typography>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    className={classes.textFieldStyle}
                    inputProps={{
                      className: classes.inputTextStyle,
                    }}
                    InputProps={{
                      classes: {
                        notchedOutline: classes.outlineStyle,
                      },
                    }}
                    fullWidth
                    onChange={(event) => setCompany(event.target.value)}
                  />
                </Grid>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography className={classes.labelStyle}>
                      Manufacturing Location
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Autocomplete
                      freeSolo
                      className={classes.textFieldStyle}
                      classes={classes}
                      style={{
                        margin: "8px 0px",
                        borderRadius: "2px",
                        padding: "0px"
                      }}
                      id="free-solo-2-demo"
                      disableClearable
                      options={locations.map((option) => option.value)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          onBlur={onChangeLocation}
                          InputProps={{
                            ...params.InputProps,
                            type: 'search',
                          }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    fullWidth
                    disabled={isCreated ? true : false}
                    className={classes.buttonStyle}
                    classes={{
                      contained: classes.buttonTextStyle,
                    }}
                    onClick={() => handleClick()}
                  >
                    Create Account
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          }
        </Paper>

      </Grid>

    </div>
  );
};

export default CompanyRegistrationForm;

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "40px",
    width: "356px",
    height: "auto",
    borderRadius: "8px",
    top: "173px",
    left: "523px",
    overflow: 'hidden'
  },
  labelStyle: {
    fontSize: "12px",
    fontWeight: 700,
    color: "#64748B",
    lineHeight: "16px",
  },
  containerStyle: {
    margin: "15px 0px",
  },
  titleStyle: {
    marginLeft: "40px",
    marginRight: "40px",
    marginTop: "24px",
    fontSize: "18px",
    fontWeight: 700,
    textAlign: "center",
  },
  subTitleStyle: {
    marginLeft: "40px",
    marginRight: "40px",
    fontSize: "14px",
    fontWeight: 400,
    color: "#64748B",
    textAlign: "center",
    lineHeight: "20px",
  },
  formContainerStyle: {
    margin: "24px 0px",
  },
  textFieldStyle: {
    margin: "8px 0px",
    borderRadius: "2px",
  },
  inputContainerStyle: {
    marginBottom: "16px",
  },
  buttonStyle: {
    padding: "8px 16px",
    borderRadius: "2px",
    background: "#3B82F6",
    fontSize: "20px",
    fontWeight: 400,
    textAlign: "center",
    color: "#FFFFFF",
    textTransform: "none",
    "&.MuiButtonBase-root:hover": {
      backgroundColor: "#3B82F6",
    },
    marginBottom: "8px",
  },
  inputTextStyle: {
    padding: "10px",
    fontWeight: 400,
  },
  buttonTextStyle: {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
  },
  outlineStyle: {
    borderColor: "#E2E8F0 !important",
  },
  inputRoot: {
    margin: "8px 0px",
    borderRadius: "2px",
    '&.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: "0px"
    }
  }
}));
